/**
 * useCardScanTracking — fires a single tracking call when the URL contains ?ref=<id>.
 *
 * Used on pages that receive scans from printed business cards
 * (e.g. HomePage for ?ref=bizcard, BecomeAffiliatePage for ?ref=bcrecruit).
 *
 * Dedupes per-session via sessionStorage so rapid-fire reloads don't over-count.
 */
import { useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export default function useCardScanTracking() {
  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      // Track either ?ref=<id> (business cards) or ?src=<id> (nav clicks / other CTAs)
      const ref = params.get('ref');
      const src = params.get('src');
      const id = ref ? ref : (src ? `src_${src}` : null);
      if (!id) return;
      const key = `card_scan_${id}`;
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, '1');
      axios.post(`${API}/card-scan/${encodeURIComponent(id)}`).catch(() => {});
    } catch (e) { /* noop */ }
  }, []);
}
